export abstract class BaseValue<T> {
  constructor(private value: T) {}

  getValue() {
    return this.value;
  }
  equals(value: T) {
    return this.getValue() === value;
  }
  equalValue(value: this) {
    return this.getValue() === value.getValue();
  }
}
